export default class RecordArrayQuery {
  constructor(store, type, params = {}) {
    this.store = store;
    this.type = type;
    this.params = params;

    this.value = null;
  }

  run() {
    let promise;

    if (this.value) {
      promise = this.value.update().catch(e => {
        if (e.errors && e.errors[0] && e.errors[0].status == 401) {
          // Do nothing, CoreAdapter will redirect to the logout page.
          // This capture makes sure the exception is not thrown when using fetcher#loadRecords with background reload.
          // In this case, no code looks up the promise, leading to uncaught exceptions if it throws.
        } else {
          throw e;
        }
      });
    } else {
      promise = this.store.query(this.type, this.params).then(records => {
        this.value = records;

        return records;
      });
    }

    return promise;
  }

  trackIncludes() {
    let includes = this.params && this.params.include;
    let models = this.value;

    if (includes && models) {
      models
        .filter(model => model.trackLoadedIncludes)
        .forEach(model => {
          model.trackLoadedIncludes(includes);
        });
    }
  }
}
